module.exports = "../Scripts/CustomConfiguration.js";